import { compose } from "recompose";
import { injectIntl } from "react-intl";
import { graphql } from "react-apollo";

import withProductsByOptions from "./withProductsByOptions";
import withSelectedOptions from "./withSelectedOptions";
import withSelectedCustomOptions from "./withSelectedCustomOptions";
import SizeGuideSlipperConfigurationQuery from "./SizeGuideSlipperConfigurationQuery.gql";

export default () => {
  let composeArray = compose(
    injectIntl,
    withProductsByOptions(),
    withSelectedOptions(),
    withSelectedCustomOptions(),
    graphql(SizeGuideSlipperConfigurationQuery, {
      props: ({ data }) => {
        return {
          loading: data.loading,
          productSizeGuideSlipper:
            data.storeConfiguration &&
            data.storeConfiguration.productSizeGuideSlipper,
        };
      },
    })
  );

  return composeArray;
};
